<div class="se-side-details-note__container">
    <div *ngIf="!!title" class="se-side-details-note__title-container">
        <span class="se-side-details-note__title">{{title | translate}}</span>
    </div>
    <div *ngIf="!!description" class="se-side-details-note-description__container">
        <span class="se-side-details-note__description">{{description}}</span>
    </div>
</div>
